module.controller('giftCollectionCtrl', ['$http', 'baseURI', 'Transform', '$scope', '$state', '$stateParams', 'brandService', 'Session', function($http, baseURI, Transform, $scope, $state, $stateParams, brandService, Session) {
  var vm = this;

  vm.email = $state.params.email;
  vm.amount = $state.params.amount;
  vm.sender = $state.params.sender;

  if ($stateParams.brand === null) {
    $scope.brand = brandService.getBrand(Session.getBrand());
  } else {
    $scope.brand = brandService.getBrand($stateParams.brand);
  }

  $scope.hideCollectByMail = $scope.brand.hideCollectByMail;

  var giftPath = 'assets/images/' + $scope.brand.name + '/card-gift.svg';
  $http.get(giftPath)
    .then(function(response) {
        $scope.giftCard = giftPath;
    })
    .catch(function(error) {
      $scope.cardId = $scope.brand.cards[0];
    });


  $http.get(baseURI + 'card/physical?Email=' + encodeURIComponent(vm.email))
    .then(function(resp){
      $scope.supportsPhysical = resp.data.Data.PhysicalProgram;
    })
    .catch(function(err){
    });
}]);
